import {instance} from '../index';

export const promoCodesApi = {
  generatePromoCode () {
    return instance.get('promos/generate')
  },
  savePromoCode (data) {
    return instance.post('exchange-membership/create-promo', data)
  },
  getActivePromoCodes () {
    return instance.get('exchange-membership/exchange-membership-promo-codes?active=true');
  },
}